// extracted by mini-css-extract-plugin
export default {"top-header-title":"SectionHeader_top-header-title__D7551","top-header-description":"SectionHeader_top-header-description__qRk-N"};